import styled from "styled-components";
import Theme from "../Theme/Theme";

export const WidgetCard = styled.div.attrs({
    className: 'widget-card',
})`
    background-color: ${props => (props.$backgroundColor ? Theme.color[props.$backgroundColor] : 'transparent')};
    border: ${props => (props.$border ?  '1.5px solid ' + Theme.color[props.$border] : 'none')};
    border-radius: ${Theme.radius['lg']};
    height: ${props => (props.$height ? props.$height : 'auto')};
    margin: ${props => (props.$margin ? Theme.spacing[props.$margin] : '0')};
    display: ${props => (props.$display ? props.$display : 'flex')};
    flex-direction: ${props => (props.$flexDirection ? props.$flexDirection : 'column')};
    justify-content: ${props => (props.$justifyContent ? props.$justifyContent : 'space-between')};
    width: ${props => (props.$width ? props.$width : '100%')};
    max-height: ${props => (props.$maxHeight ? props.$maxHeight : null)};
    min-height: ${props => (props.$minHeight ? props.$minHeight : null)};


    .widget-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: ${Theme.spacing['s05']} ${Theme.spacing['s05']} ${Theme.spacing['s03']};
        
        .widget-title{
            display: flex;
            align-items: center;
        }

        .widget-date{
            display: flex;
            align-items: center;
        }
        .widget-buttons{
            background-color: ${Theme.color['neutral-1']};
            border-radius: 30px;
            width: 369px;
            .button{
                height: 24px;
                width: 123px;
                background-color: ${Theme.color['neutral-1']};
                color: ${Theme.color['black-1']};
                &:active{
                    background-color:${Theme.color['white']} !important;
                    border-color:${Theme.color['black-1']} !important;
                    border: ${Theme.border.md}

                }
                &:focus{
                    box-shadow: transparent !important;

                }
            }
        }
    }

    .widget-content {
        padding: 0 ${Theme.spacing['s05']} ${Theme.spacing['s03']};

        .hidden{
            display: none;
        }
    }

    .full-height{
        height: 100%;
    }
    

    .chart{
        display: flex;
        align-items: center;
        justify-content: center;
    }

`;